module.exports = __webpack_public_path__ + "img/topicDomesticChemicals.863aed54.png";